import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { axiosInstance } from './axios';

class ManifestApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/wms/manifest');
  }

  protected transformNode(node: any) {
    // Transform manifest data if needed
    return node;
  }

  // Handle complete action
  async complete(sorters: any, filters: any, payload: any, query: any, headers: any, meta: any) {
    if (meta?.manifestId) {
      const response = await axiosInstance.put(`${this.baseURL}/${meta.manifestId}/complete`);
      return response.data;
    }
    throw new Error('manifestId is required for complete action');
  }

  // Handle discard action
  async discard(sorters: any, filters: any, payload: any, query: any, headers: any, meta: any) {
    if (meta?.manifestId) {
      const response = await axiosInstance.put(`${this.baseURL}/${meta.manifestId}/discard`);
      return response.data;
    }
    throw new Error('manifestId is required for discard action');
  }

  // Handle add-item action
  async 'add-item'(sorters: any, filters: any, payload: any, query: any, headers: any, meta: any) {
    if (meta?.manifestId && payload?.itemCode && payload?.itemType) {
      const response = await axiosInstance.post(`${this.baseURL}/${meta.manifestId}/item`, {
        itemCode: payload.itemCode,
        itemType: payload.itemType,
      });
      return response.data;
    }
    throw new Error('manifestId, itemCode, and itemType are required for add-item action');
  }

  // Handle remove-item action
  async 'remove-item'(
    sorters: any,
    filters: any,
    payload: any,
    query: any,
    headers: any,
    meta: any,
  ) {
    if (meta?.manifestId && payload?.itemCode) {
      const response = await axiosInstance.delete(`${this.baseURL}/${meta.manifestId}/item`, {
        data: { itemCode: payload.itemCode },
      });
      return response.data;
    }
    throw new Error('manifestId and itemCode are required for remove-item action');
  }
}

export default ManifestApiClient;
